"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MockWindowAPI = void 0;
class MockWindowAPI {
  constructor() {
    this.createWindowObject = jest.fn();
    this.exposeLaunchFunction = jest.fn();
    this.exposeFlows = jest.fn();
    this.calculateSummaries = jest.fn();
    this.evaluateReset = jest.fn();
  }
}
exports.MockWindowAPI = MockWindowAPI;